import request from '@/utils/request'

//管理员端登录
export function login(username, password,pageCode) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password,
      pageCode
    }
  })
}
//商户端登录
export function loginMerchant(username, password,pageCode) {
  return request({
    url: '/merchant/admin/login',
    method: 'post',
    data: {
      username,
      password,
      pageCode
    }
  })
}
//业务端登录
export function loginAgent(username, password,pageCode) {
  return request({
    url: '/agent/admin/login',
    method: 'post',
    data: {
      username,
      password,
      pageCode
    }
  })
}
//资方端端登录
export function loginCapital(username, password,pageCode) {
  return request({
    url: '/fund/admin/login',
    method: 'post',
    data: {
      username,
      password,
      pageCode
    }
  })
}
export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}
export function getCode() {
  return request({
    url: '/admin/getCodeBase64',
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js